$(document).foundation();

function resetStoryCarousel(element) {
  // adjust heights and widths of photos
  var tallestSlide = 0;
  element.find('.carousel-cell').each(function() {
    tallestSlide = Math.max(tallestSlide, $(this).height());
  });
  element.find('.carousel-cell').height(tallestSlide);
}

function adjustTextClamps() {
  $('[data-text-clamp]').each(function() {
    var clampInfo = $(this).data('text-clamp').split(',');
    var clampValue = 0;
    if (Foundation.MediaQuery.is('large')) {
      clampValue = parseInt(clampInfo[2]);
    } else if (Foundation.MediaQuery.is('medium')) {
      clampValue = parseInt(clampInfo[1]);
    } else {
      clampValue = parseInt(clampInfo[0]);
    }
    $clamp(this, {clamp: clampValue});
  })
}

function adjustAspectRatio() {
  $('[data-aspect-ratio]').each(function() {
    var $current = $(this);
    var aspectRatio = $current.data('aspect-ratio').split(':');
    if (aspectRatio.length == 2) {
      $current.height((parseInt(aspectRatio[1]) * 1.0) / parseInt(aspectRatio[0]) * $current.width());
    }
  })
}

function adjustSingleStoryQuote() {
  // special handling for single story's hero: set height to quote in accordance to orientation
  // we use 1.2 to determine if a screen is considered still portrait
  var maxLines = (window.innerWidth * 1.0 / window.innerHeight > 1.2) ? 3 : 5;
  var $singleStoryQuote = $('.single-story .hero .story-quote .story-quote-inner');
  if ($singleStoryQuote.length > 0) {
    var $clone = $singleStoryQuote.clone().css({
      'position': 'fixed',
      'top': -99999,
      'left': -99999,
    }).appendTo($singleStoryQuote.parent());
    var $clonedHeading = $clone.find('h2');
    $clonedHeading.html('A');
    var singleLineHeight = $clonedHeading.outerHeight();
    var singleLineMargin = $clonedHeading.outerHeight(true) - $clonedHeading.outerHeight();
    $singleStoryQuote.css('min-height', maxLines * singleLineHeight + singleLineMargin);
    $clone.remove();
  }

}

jQuery(document).ready(function($) {

  // mobile toggle
  $('.mobile-toggle').on('click', function(e) {
    $('body').toggleClass('mobile-menu--is-open')
    $('.hamburger').toggleClass('is-active')
    e.preventDefault()
    e.stopPropagation()
  })

  // like button on single story page
  $('.pld-undo-trigger').parents('.pld-like-dislike-wrap').addClass('liked');
  $('.pld-like-dislike-wrap').on('click', function(e) {
    setTimeout(function() {
      var $wrapper = $(e.target).closest('.pld-like-dislike-wrap');
      if ($wrapper.find('.pld-like-trigger').is('.pld-undo-trigger')) {
        $wrapper.addClass('liked');
      } else {
        $wrapper.removeClass('liked');
      }  
    }, 750); // forced to use timeout to wait for ajax call, see post-like-dislike plugin 
  });

  // block colored box image
  document.fonts.ready.then(function() {
    // carousel sets funny height if initialized before font is loaded, because used font is very narrow.
    // forced to use window on load, having trouble finding "on font X loaded" event
    $('.block-carousel-stories').each(function() {
      var $block = $(this)
      var $carousel = $block.find('.carousel').flickity({
        cellSelector: '.carousel-cell',
        cellAlign: 'left',
        setGallerySize: true,
        pageDots: false,
        // fade: true,
        prevNextButtons: false,
        percentPosition: false,
        imagesLoaded: true,
        wrapAround: true,
        draggable: true,
        // autoPlay: 3500,
        on: {
          ready: function() {
            resetStoryCarousel(this.$element);
          },
          reposition: function() {
            resetStoryCarousel(this.$element);
          },
          select: function(index) {
            var $parent = this.$element.parents('.block-carousel-stories');
            $parent.find('.current-slide').html(index+1);
            $parent.find('.total-slides').html($parent.find('.carousel-cell').length);
          }
        }
      })
      $block.find('.previous').on('click', function(e) {
        $carousel.flickity('previous')
        e.preventDefault()
      })
      $block.find('.next').on('click', function(e) {
        $carousel.flickity('next')
        e.preventDefault()
      })
      $block.find('.pager-container a').on("click", function() {
        $(this).parents('.block-carousel-stories').find('.carousel').flickity('next', true);
      })
      adjustTextClamps();
    });  
    adjustSingleStoryQuote();
    adjustAspectRatio();
    //faq accordion - scroll to opened question
    var urlHash = window.location.hash;
    if (urlHash) urlHash = window.location.hash.substring(1);
    if (urlHash) {
      if ($('.accordion-content#'+urlHash).length > 0) {
        $('html, body').animate({scrollTop: $('.accordion-content#'+urlHash).parent().offset().top - $('header').outerHeight() - 32}, 600);
      }
    }
  });

  $('.block-grid-stories').on('click', '.cell-result', function(e) {
    var $cell = $(this)
    $('.stories-sidebar .text').html($cell.find('.payload').html())
    $('.stories-sidebar').addClass('stories-sidebar--is-showing')
    $('body').addClass('sidebar-active');
    e.preventDefault()
    e.stopPropagation()
  })

  $('.block-our-team').on('click', '.cell-person', function(e) {
    var $cell = $(this)
    $('.person-sidebar .text').html($cell.find('.payload').html())
    $('.person-sidebar').addClass('person-sidebar--is-showing')
    $('body').addClass('sidebar-active');
    e.preventDefault()
    e.stopPropagation()
  })

  $('.block-our-partners').on('click', '.cell-partner', function(e) {
    var $cell = $(this)
    $('.partner-sidebar .text').html($cell.find('.payload').html())
    $('.partner-sidebar').addClass('partner-sidebar--is-showing')
    $('body').addClass('sidebar-active');
    e.preventDefault()
    e.stopPropagation()
  })

  $('.sidebar-screen').on('click', function() {
    $('.stories-sidebar').removeClass('stories-sidebar--is-showing')
    $('.person-sidebar').removeClass('person-sidebar--is-showing')
    $('.partner-sidebar').removeClass('partner-sidebar--is-showing')
    $('body').removeClass('sidebar-active');
  })

  $('.close[data-toggle]').on('click', function() {
    $('body').removeClass('sidebar-active');
  })

  // footer SwAA LinkedIn should open in new tab
  $('ul#menu-footer li#menu-item-872 a').attr('target','blank');

  // add external link icon to non-host links and let them open in new window
  var hostUrl = document.location.host;
  $('main').find('a:not(.button, .social-media-item, .arrow-link )').each(function(){
    var $anchor = $(this);
    var $children = $anchor.children();
    var imageAnchor = ($children.length == 1 && $children.is('img'));
    var url = $anchor.attr('href');
    if (url.indexOf('http') === 0 && !imageAnchor) {
      if (!url.includes(hostUrl)) {
        if ($anchor.children().filter('p').length > 0) {
          $anchor.children().last().addClass('external-link');
        } else {
          $anchor.addClass('external-link');
        }
        $anchor.attr('target', '_blank');
      }
    }
  })

  // map
  if ($('#stories-map').length) {
    function initMap() {

      map = new google.maps.Map(document.getElementById("stories-map"), {
        zoom: 16,
        minZoom: 3,
        streetViewControl: false,
        mapTypeControl: false,
        fullscreenControl: false,
        zoomControlOptions: {
          position: google.maps.ControlPosition.RIGHT_BOTTOM
        },
        zoomControl: true,
        fullscreenControl: false,
        center: { lat: 40.690960, lng: -73.984880 },
      })

      if (true) {
        // shape
        var dbpCoordinates = [
          {lat: 40.689815, lng: -73.992620},
          {lat: 40.692516, lng: -73.991356},
          {lat: 40.692548, lng: -73.990863},
          {lat: 40.693834, lng: -73.990349},
          {lat: 40.696063, lng: -73.991054},
          {lat: 40.694989, lng: -73.988632},
          {lat: 40.696128, lng: -73.988618},
          {lat: 40.695884, lng: -73.983240},
          {lat: 40.694859, lng: -73.983763},
          {lat: 40.694794, lng: -73.982450},
          {lat: 40.693639, lng: -73.982472},
          {lat: 40.693769, lng: -73.983264},
          {lat: 40.692792, lng: -73.982707},
          {lat: 40.692044, lng: -73.981763},
          {lat: 40.691914, lng: -73.978955},
          {lat: 40.690694, lng: -73.978762},
          {lat: 40.690596, lng: -73.977262},
          {lat: 40.689799, lng: -73.977069},
          {lat: 40.689815, lng: -73.978505},
          {lat: 40.689050, lng: -73.978183},
          {lat: 40.689002, lng: -73.979362},
          {lat: 40.688286, lng: -73.979319},
          {lat: 40.687814, lng: -73.978342},
          {lat: 40.686821, lng: -73.978226},
          {lat: 40.686935, lng: -73.977359},
          {lat: 40.685178, lng: -73.977016},
          {lat: 40.685389, lng: -73.975259},
          {lat: 40.684023, lng: -73.975002},
          {lat: 40.683795, lng: -73.973909},
          {lat: 40.683030, lng: -73.973759},
          {lat: 40.683453, lng: -73.975923},
          {lat: 40.684364, lng: -73.978430},
          {lat: 40.684852, lng: -73.978088},
          {lat: 40.685227, lng: -73.978323},
          {lat: 40.689262, lng: -73.988694},
          {lat: 40.688692, lng: -73.989149},
          {lat: 40.689815, lng: -73.992620}
        ]
        var dbpPath = new google.maps.Polyline({
          path: dbpCoordinates,
          geodesic: true,
          strokeColor: "#000000",
          strokeOpacity: 1.0,
          strokeWeight: 2,
        })

        var strX = ''
        var strY = ''
        for(var z=0;z<dbpCoordinates.length;z++) {
          strX += dbpCoordinates[z].lng+','
          strY += dbpCoordinates[z].lat+','
        }
        dbpPath.setMap(map)
      }

      // set style
      var mapType = new google.maps.StyledMapType([ { "featureType": "water", "elementType": "geometry", "stylers": [ { "color": "#e9e9e9" }, { "lightness": 17 } ] }, { "featureType": "landscape", "elementType": "geometry", "stylers": [ { "color": "#f5f5f5" }, { "lightness": 20 } ] }, { "featureType": "road.highway", "elementType": "geometry.fill", "stylers": [ { "color": "#ffffff" }, { "lightness": 17 } ] }, { "featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [ { "color": "#ffffff" }, { "lightness": 29 }, { "weight": 0.2 } ] }, { "featureType": "road.arterial", "elementType": "geometry", "stylers": [ { "color": "#ffffff" }, { "lightness": 18 } ] }, { "featureType": "road.local", "elementType": "geometry", "stylers": [ { "color": "#ffffff" }, { "lightness": 16 } ] }, { "featureType": "poi", "elementType": "geometry", "stylers": [ { "color": "#f5f5f5" }, { "lightness": 21 } ] }, { "featureType": "poi.park", "elementType": "geometry", "stylers": [ { "color": "#dedede" }, { "lightness": 21 } ] }, { "elementType": "labels.text.stroke", "stylers": [ { "visibility": "on" }, { "color": "#ffffff" }, { "lightness": 16 } ] }, { "elementType": "labels.text.fill", "stylers": [ { "saturation": 36 }, { "color": "#333333" }, { "lightness": 40 } ] }, { "elementType": "labels.icon", "stylers": [ { "visibility": "off" } ] }, { "featureType": "transit", "elementType": "geometry", "stylers": [ { "color": "#f2f2f2" }, { "lightness": 19 } ] }, { "featureType": "administrative", "elementType": "geometry.fill", "stylers": [ { "color": "#fefefe" }, { "lightness": 20 } ] }, { "featureType": "administrative", "elementType": "geometry.stroke", "stylers": [ { "color": "#fefefe" }, { "lightness": 17 }, { "weight": 1.2 } ] } ])
      map.mapTypes.set('snazzyMapType', mapType)
      map.setMapTypeId('snazzyMapType')

      map.addListener('zoom_changed', function() {
        infoWindow.close()
      })

    }
    initMap()
  }

  // advanced search filters
  if ($('.filters-search-results').length > 0) {
    // payloads
    $('.filter .label-icon').on('click', function() {
      if (Foundation.MediaQuery.current == 'small') {
        var $filter = $(this).parent()
        $filter.siblings().removeClass('filter-payload--is-showing')
        $filter.toggleClass('filter-payload--is-showing')
        $('body').toggleClass('filter--is-showing')
      }
    })
    $('.payload .payload-search input[type="text"]').on("input", function() {
      var searchQuery = $(this).val().trim().toLowerCase();
      $(this).parents('.payload').find('.payload-content p').each(function() {
        if (searchQuery == '') {
          $(this).removeClass('hide');
        } else {
          var filterString = $(this).find('label').html().toLowerCase();
          if (filterString.includes(searchQuery)) {
            $(this).removeClass('hide');
          } else {
            $(this).addClass('hide');
          }  
        }
      })
    })

    // checkbox is clicked
    $('.filter input[type="checkbox"], .filter input[type="radio"]').change(function() {
      refreshTags()
      refreshResults()
    })

    // disable form submit
    $('.filters-search-results form.filters').on('submit', function() {
      return false
    })

    var debounce_timer;
    $('.filter.filter-text input[type="text"]').on('input', function() {
      if (debounce_timer) {
        window.clearTimeout(debounce_timer)
      }
      debounce_timer = window.setTimeout(function() {
        refreshTags()
        refreshResults()
      }, 700)
    })

    // selected filters tag on click - remove it
    $('.tags').on('click', '.tag', function(e) {
      var $a = $(this)
      var name = $a.data('name')
      var value = $a.data('value')
      var type = $a.data('type')
      if (type == 'checkbox' || type == 'radio') {
        $('.filter input[value="' + value + '"]').click()
      }
      if (type == 'search') {
        $('.filter input[type="search"]').val('')
        refreshTags()
        refreshResults()
      }
      if (type == 'text') {
        $('.filter.filter-text input[type="text"]').val('')
        refreshTags()
        refreshResults()
      }
      e.preventDefault()
    })

    function refreshTags() {
      var $tags = $('.tags')
      $tags.empty()
      $('.filter input[type="checkbox"], .filter input[type="radio"], .filter input[type="search"], .filter.filter-text input[type="text"], input[type="hidden"].filter-hidden').each(function() {
        var $input = $(this)
        var type = $input.attr('type')
        if (type == 'search') {
          if ($input.val() != '') {
            $tags.append('<a href="#" data-type="search" data-name="state_province_covered" data-value="' + $input.val()  + '" class="tag">' + $input.val() + ' <i class="far fa-times"></i></a>')
          }
        }
        if (type == 'text') {
          if ($input.val() != '') {
            $tags.append('<a href="#" data-type="text" data-name="keyword" data-value="' + $input.val()  + '" class="tag">' + $input.val() + ' <i class="far fa-times"></i></a>')
          }
        }
        if (type == 'checkbox' || type == 'radio') {
          if ($input.is(':checked')) {
            var label = $input.next().html()
            var name = $input.attr('name')
            var value = $input.attr('value')
            $tags.append('<a href="#" data-type="' + type + '" data-name="' + name + '" data-value="' + value + '" class="tag">' + label + ' <i class="far fa-times"></i></a>')
          }
        }
      })
      if ($tags.find('a').length == 0) {
        $('.filters-search-results').removeClass('filters-search-results--has-tags')
      } else {
        $('.filters-search-results').addClass('filters-search-results--has-tags')
      }
    }

    function refreshResults() {
      var params = []
      $('.filter input[type="checkbox"], .filter input[type="radio"], .filter input[type="search"], .filter.filter-text input[type="text"], input[type="hidden"].filter-hidden').each(function() {
        var $input = $(this)
        var type = $input.attr('type')
        var name = $input.attr('name')
        var value = '';
        if (type == 'search') {
          value = $input.val()
          if (value) {
            params.push(name + '=' + value)
          }
        }
        if (type == 'checkbox' || type == 'radio') {
          if ($input.is(':checked')) {
            value = $input.attr('value')
            params.push(name + '=' + value)
          }
        }
        if (type == 'text') {
          value = $input.val()
          if (value) {
            params.push(name + '=' + value)
          }
        }
        if (type == 'hidden') {
          value = $input.val()
          if (value) {
            params.push(name + '=' + value)
          }
        }
      })
      var url = window.location.pathname + '?' + params.join('&')
      $.ajax({
        url: url,
        cache: true,
        dataType: 'html',
        beforeSend: function(xhr) {
          $('.search-results').empty()
          $('.filters-search-results').addClass('filters-search-results--is-loading')
        }
      }).done(function(html) {
        $('.filters-search-results').removeClass('filters-search-results--is-loading')
        var searchResultsHtml = $(html).find('.search-results').html()
        $('.search-results').html(searchResultsHtml)
        $('.keyword-search input[type="text"]').val('')
        history.pushState(null, null, url)
        adjustAspectRatio()
      })
    }

    refreshTags()

    // pagination
    $('.filters-search-results').on('click', '.pagination a', function(e) {
      var $pagination = $(this).closest('.pagination')
      var $filtersSearchResults = $(this).closest('.filters-search-results')
      var ppg = 120
      if (parseInt($pagination.data('pagination-per-page')) > 0) {
        ppg = parseInt($pagination.data('pagination-per-page'))
      }
      $('.pagination a').removeClass('active')
      var $a = $(this)
      var index = parseInt($a.html()) - 1
      var start = index * ppg
      var end = start + ppg
      $a.addClass('active')
      var offsetTop = $filtersSearchResults.offset().top - 150
      $('.filters-search-results').addClass('filters-search-results--is-hidden')
      $('html, body').animate({scrollTop: offsetTop }, 600, function() {
        $('.filters-search-results').removeClass('filters-search-results--is-hidden')
        $('.search-results .cell-result').addClass('hide').slice(start, end).removeClass('hide')
      })
      e.preventDefault()
    })
  }

  // header shrink on scroll
  $(window).on('scroll', function() {
    if ($(window).scrollTop() > 0) {
      $('header').addClass('is--scrolled')
    } else {
      $('header').removeClass('is--scrolled')
    }
  })

  // calendar dot click
  $(document).on('click', '.block-calendar .day-has-events', function(e) {
    if (Foundation.MediaQuery.current == 'small') {
      var date = $(this).data('event-date')
      $('.mobile-event').addClass('hide')
      $('.mobile-event[data-event-date="' + date + '"]').removeClass('hide')
    }
  })

	// Adds Flex Video to YouTube and Vimeo Embeds
  $('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
    $(this).parent().addClass('responsive-embed widescreen')
  })

  var resizeTimeout = null;
  // debugger
  $(window).on('resize', function() {
    if (resizeTimeout) clearTimeout();
    resizeTimeout = setTimeout(function() {
      clearTimeout(resizeTimeout);
      adjustSingleStoryQuote();
      adjustTextClamps();
      adjustAspectRatio();
    }, 10);
    $('.debugger .column-width').html($('.debugger .cell').eq(0).width())
    $('.debugger .gutter-width').html(parseInt($('.debugger .cell').eq(0).css('margin-left')) * 2)
    $('.debugger .container-padding').html(parseInt($('.debugger .grid-container').eq(0).css('padding-left')) * 2)
  }).trigger('resize')

  $('.debugger').on('click', function(e) {
    $(this).remove()
  })

});

/**
 * Letter Signatures reactive UI
 */
(function ($) {

  document.addEventListener('alpine:init', function() {
    window.Alpine.data('letterSignatures', function(selectedTags, keyword) {
      return {
        isLoading: true,
        total: 0,
        isReady: false,
        data: [],
        perPage: 21,
        totalPages: 0,
        currentPage: 1,
        visiblePages: 10,
        activeTagIds: [],
        activeTags: [],
        keyword: '',

        init: function() {
          this.activeTagIds = selectedTags;
          this.keyword = keyword;
          this._buildSelectedTags();
          this._refreshData(true);
        },

        pages: function() {
          return this._pagination(this.currentPage, this.totalPages)
        },

        previousPage: function() {
          var page = this.currentPage > 1 ? this.currentPage - 1 : null;
          this.setPage(page)
        },
      
        nextPage: function() {
          var page = this.currentPage < this.totalPages ? this.currentPage + 1 : null;
          this.setPage(page)
        },

        setPage: function(page) {
          var _this = this;
          var params = this._getQueryParams();
          this.currentPage = page;
          this.isLoading = true;

          // Fetch initial data
          $.ajax({
            url: window.swaa.ajax_url,
            data: params.join('&') + '&action=fetch_signatures&page=' + _this.currentPage,
          })
          .done(function (res) {
            _this.data = res.data;
            // Scroll to top
            if (_this.$refs.main && 'scrollIntoView' in _this.$refs.main) {
              _this.$refs.main.scrollIntoView()
            }
          })
          .always(function() {
            _this.isLoading = false;
            _this.isReady = true;
          })
        },

        hasActiveTags: function() {
          return this.activeTags.length > 0;
        },

        hasData: function() {
          return this.data.length > 0;
        },

        hasPrevLink: function() {
          return this.pages().length > 1;
        },

        hasNextLink: function() {
          return this.pages().length > 1;
        },

        isFirstPage: function() {
          return this.currentPage == 1;
        },

        isLastPage: function() {
          return this.currentPage == this.totalPages;
        },

        toggleActiveTags: function(id, label, type) {
          var targetTags = this._findActiveTagsById(id);

          // Check if this id is exists in the activeTags
          if (targetTags !== -1) {
            this.activeTags.splice(targetTags, 1);
          } else {
            this.activeTags.push({
              id: id,
              value: id,
              label: label,
              type: 'checkbox',
              name: type + '[]',
            })
          }

          this._refreshData();
        },

        removeTag: function(id) {
          var targetTags = this._findActiveTagsById(id);

          if (targetTags !== -1) {
            var targetTagData = this.activeTags[targetTags];
            this.activeTags.splice(targetTags, 1);
            
            // Sync the activeTagsIds
            var activeTagIdsIndex = this.activeTagIds.indexOf(id)
            if (activeTagIdsIndex !== -1) {
              this.activeTagIds.splice(activeTagIdsIndex, 1);
            }

            // If removed tags is search type tag
            if (targetTagData.type === 'search') {
              this.keyword = '';
            }

            this._refreshData();
          }
        },

        isInActiveTags: function(id) {
          console.log(id)
        },

        clearFilters: function() {
          this.activeTags = [];
          this.activeTagIds = [];
          this.keyword = '';
          this._refreshData();
        },

        searchResults: function() {
          // Remove all tags with type search
          var tagSearch = this._findActiveTagsById('search');
          if (tagSearch !== -1) {
            this.activeTags.splice(targetTags, 1);
          }

          this.activeTags.push({
            id: 'search',
            value: this.keyword,
            label: this.keyword,
            type: 'search',
            name: 'keyword',
          })

          this._refreshData();
        },

        _refreshData: function(isInitial) {
          var _this = this;
          var params = this._getQueryParams();
          var url = window.location.pathname + '?' + params.join('&')
          
          this.isLoading = true;
          this.currentPage = 1;

          $.ajax({
            url: window.swaa.ajax_url,
            data: params.join('&') + '&action=fetch_signatures',
          })
          .done(function (res) {
            _this.total = res.meta.total;
            _this.data = res.data;
            _this.perPage = res.meta.per_page;
            _this.totalPages = res.meta.total_page;
            if (!isInitial) {
              history.pushState(null, null, url)
            }
          })
          .always(function() {
            _this.isLoading = false;
            if (isInitial) {
              _this.isReady = true;
            }
          })
        },

        _getQueryParams: function() {
          var params = [];

          for (var i = 0; i < this.activeTags.length; i++) {
            var tag = this.activeTags[i];
            
            switch (tag.type) {
              case 'checkbox':
              case 'radio':
                params.push(tag.name + '=' + tag.value);
                break;

              case 'search':
                params.push('keyword=' + tag.value);
                break;
            }
          }

          return params;
        },

        _buildSelectedTags: function() {
          for (let i = 0; i < this.activeTagIds.length; i++) {
            const element = this.activeTagIds[i];
            var $element = $('.filter.reactive input[value="' + element + '"]');

            this.activeTags.push({
              id: element,
              value: element,
              label: $element.siblings('label').text(),
              type: 'checkbox',
              name: $element.attr('name'),
            })
          }

          if (this.keyword) {
            this.activeTags.push({
              id: 'search',
              value: this.keyword,
              label: this.keyword,
              type: 'search',
              name: 'keyword',
            })
          }
        },

        _findActiveTagsById: function(id) {
          for (var i = 0; i < this.activeTags.length; i++) {
            if (this.activeTags[i].id === id) {
              return i;
            }
          }
          return -1;
        },

        // @see https://gist.github.com/kottenator/9d936eb3e4e3c3e02598
        _pagination: function(currentPage, pageCount) {
          var delta;
          if (pageCount <= 7) {
            // delta === 7: [1 2 3 4 5 6 7]
            delta = 7
          } else {
            // delta === 2: [1 ... 4 5 6 ... 10]
            // delta === 4: [1 2 3 4 5 ... 10]
            delta = currentPage > 4 && currentPage < pageCount - 3 ? 2 : 4
          }
          
          var range = {
            start: Math.round(currentPage - delta / 2),
            end: Math.round(currentPage + delta / 2)
          }

          if (range.start - 1 === 1 || range.end + 1 === pageCount) {
            range.start += 1
            range.end += 1
          }

          var pages = currentPage > delta
            ? this._getRange(Math.min(range.start, pageCount - delta), Math.min(range.end, pageCount))
            : this._getRange(1, Math.min(pageCount, delta + 1))

          var withDots = function(value, pair) {
            return pages.length + 1 !== pageCount ? pair : [value]
          }

          if (pages[0] !== 1) {
            pages = withDots(1, [1, '...']).concat(pages)
          }

          if (pages[pages.length - 1] < pageCount) {
            pages = pages.concat(withDots(pageCount, ['...', pageCount]))
          }

          return pages
        },

        _getRange: function(start, end) {
          var range = [];
          for (var i = start; i <= end; i++) {
            range.push(i);
          }
          return range;
        },
      }
    });
  });

})(jQuery);
